import {Component, OnInit} from '@angular/core';
import {AnalyticsService} from 'app/@core/utils';
import {SeoService} from 'app/@core/utils';
import {IconService} from './common/services/icon.service';

@Component({
  selector: 'ngx-app',
  standalone: false,
  template: `
    <splash-screen></splash-screen>
    <router-outlet></router-outlet>
  `,
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService,
              private seoService: SeoService,
              private iconService: IconService,
  ) {
  }

  ngOnInit() {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.iconService.registerIcons();
  }
}
